export default "__VITE_ASSET__DzjoxQxV__"